export const FULL_CATALOG = {
    "Vegetales & Verduras": [
        "Acelga", "Champiñón", "Judía Pinta", "Palmito", "Ají Llanerón", "Tomate",
        "Ajo", "Chirivía", "Judía Pinta en Vaina", "Papa", "Pimiento Choricero", "Tomate Mini",
        "Alcachofa", "Chayote", "Lechuga Hoja de Roble", "Pepino", "Pimiento Morrón", "Tomate Cherri",
        "Alcaparra", "Coles Bruselas", "Lechuga Iceberg", "Pepino Mini", "Pimiento Lamuyo", "Tomate RAF",
        "Batata", "Endibia", "Lechuga Romana", "Pepino Kirby", "Pimiento Italiano", "Zanahoria Nantesa",
        "Berenjena", "Espárrago", "Lechuga Batavia", "Ají Dulce", "Pimiento Verde", "Zanahoria Imperator",
        "Boniato", "Espinaca", "Lechuga Cogollo", "Pimiento Piquillo", "Pimiento Rojo", "Zanahoria Chantenay",
        "Brócoli", "Guisante", "Maíz Dulce", "Chile Dulce", "Pimiento California", "Rutabaga",
        "Brotes", "Habas Verdes", "Maíz Elote", "Pimiento Padrón", "Pimiento de Asar", "Pak Choi",
        "Calabacín", "Jengibre", "Maíz Baby", "Mini Pimientos", "Pimiento Amarillo", "Apio Nabo",
        "Canónigo", "Judías Verdes", "Mandioca", "Pimiento Gernika", "Pimiento Naranja", "Colinabo",
        "Cebolla", "Judías en Vaina", "Nabo", "Ají Pepón", "Pimiento Ñora", "Remolacha",
        "Okra", "Rábano", "Col China", "Daikon", "Romanesco", "Aguacate", "Plátano Macho", "Plátano Verde"
    ],
    "Hierbas & Micros": [
        "Eneldo", "Perejil Rizado", "Albahaca", "Hinojo (rama)", "Tomillo", "Orégano",
        "Cebollino", "Romero", "Laurel", "Perifollo", "Mejorana", "Menta",
        "Estragón", "Salvia", "Hierbabuena", "Microperejil", "Melisa", "Lavanda",
        "Apio", "Cebolleta", "Puerro", "Cilantro", "Berro", "Bimi", "Kale"
    ],
    "Frutas": [
        "Manzana Royal Gala", "Manzana Granny Smith", "Manzana Fuji", "Manzana Red Delicious", "Manzana Golden",
        "Pera Conferencia", "Pera Blanquilla", "Pera Ercolina", "Plátano", "Banana",
        "Naranja de Mesa", "Naranja de Zumo", "Mandarina", "Clementina", "Limón", "Lima", "Pomelo",
        "Uva Blanca", "Uva Roja", "Uva Negra", "Uva sin Semilla", "Cereza", "Picota",
        "Fresa", "Fresón", "Frambuesa", "Arándano", "Mora", "Grosella",
        "Melocotón", "Nectarina", "Paraguayo", "Albaricoque", "Ciruela Roja", "Ciruela Amarilla",
        "Melón Piel de Sapo", "Melón Galia", "Melón Cantalupo", "Sandía Negra", "Sandía Rayada",
        "Piña", "Mango", "Papaya", "Kiwi Verde", "Kiwi Gold", "Coco", "Granada", "Higo", "Breva", "Caqui",
        "Chirimoya", "Guayaba", "Maracuyá", "Pitahaya", "Rambután", "Lichi", "Mangostán", "Physalis", "Kumquat"
    ],
    "Carnes": [
        "Ternera Solomillo", "Ternera Entrecot", "Ternera Chuletón", "Ternera Lomo Bajo", "Ternera Ossobuco",
        "Ternera Carne Picada", "Ternera para Guisar", "Ternera Hígado", "Ternera Lengua",
        "Cerdo Lomo", "Cerdo Solomillo", "Cerdo Chuleta", "Cerdo Costilla", "Cerdo Panceta", "Cerdo Secreto",
        "Cerdo Presa", "Cerdo Pluma", "Cerdo Carrillada", "Cerdo Jamón Fresco",
        "Cordero Chuletillas", "Cordero Pierna", "Cordero Paletilla", "Cabrito"
    ],
    "Aves": [
        "Pollo Entero", "Pollo Pechuga", "Pollo Trasero", "Pollo Muslo", "Pollo Jamoncito", "Pollo Alas",
        "Pollo de Corral", "Gallina", "Pavo Pechuga", "Pavo Muslo", "Pavo Solomillo",
        "Pato Magret", "Pato Confit", "Codorniz", "Picantón"
    ],
    "Pescados & Mariscos": [
        "Salmón", "Merluza", "Bacalao", "Atún Rojo", "Bonito", "Emperador", "Lenguado", "Rodaballo", "Lubina", "Dorada",
        "Sardina", "Boquerón", "Caballa", "Jurel", "Salmonete", "Rape", "Congrio", "Trucha",
        "Gamba Blanca", "Gamba Roja", "Langostino", "Cigala", "Bogavante", "Langosta", "Centollo", "Nécora", "Buey de Mar",
        "Mejillón", "Almeja", "Berberecho", "Navaja", "Ostra", "Vieira", "Zamburiña",
        "Calamar", "Sepia", "Pulpo", "Chipirón"
    ],
    "Charcutería & Quesos": [
        "Jamón Serrano", "Jamón Ibérico", "Chorizo", "Salchichón", "Lomo Embuchado", "Fuet", "Butifarra", "Sobrasada",
        "Pavo Cocido", "Jamón York", "Mortadela", "Bacon",
        "Queso Manchego", "Queso Idiazábal", "Queso Cabrales", "Queso Tetilla", "Queso Mahón",
        "Queso Fresco", "Queso de Burgos", "Mozzarella", "Burrata", "Parmesano", "Gorgonzola", "Roquefort",
        "Cheddar", "Gouda", "Emmental", "Brie", "Camembert", "Queso de Cabra", "Feta"
    ],
    "Lácteos & Huevos": [
        "Leche Entera", "Leche Semidesnatada", "Leche Desnatada", "Leche sin Lactosa", "Leche de Soja", "Leche de Avena", "Leche de Almendra",
        "Nata para Cocinar", "Nata para Montar", "Mantequilla", "Margarina",
        "Yogur Natural", "Yogur Griego", "Yogur de Sabores", "Kéfir",
        "Huevos XL", "Huevos L", "Huevos M", "Huevos Camperos", "Huevos Ecológicos", "Huevos de Codorniz"
    ],
    "Pulpas de Fruta": [
        "Pulpa de Mora", "Pulpa de Lulo", "Pulpa de Maracuyá", "Pulpa de Granadilla", "Pulpa de Guanábana",
        "Pulpa de Chirimoya", "Pulpa de Mango", "Pulpa de Piña", "Pulpa de Fresa", "Pulpa de Tomate de Árbol",
        "Pulpa de Guayaba", "Pulpa de Papaya", "Pulpa de Limón", "Pulpa de Mandarina", "Pulpa de Tamarindo",
        "Pulpa de Borojó", "Pulpa de Naranjilla", "Pulpa de Taxo", "Pulpa de Uvilla", "Pulpa de Coco"
    ],
    "Panadería": [
        "Barra de Pan", "Baguette", "Chapata", "Pan de Payés", "Pan Integral", "Pan de Centeno", "Pan de Maíz",
        "Pan de Molde", "Pan de Hamburguesa", "Pan de Perrito", "Pan Rallado", "Picos y Regañás"
    ]
};
